import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button as MuiButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {
  Description as DescriptionIcon,
  CameraAlt as CameraAltIcon,
  Info as InfoIcon,
} from '@mui/icons-material';
import { Typography } from '@tucar/pit-stop';

import { DocumentUploadUtils } from '../../../../../helpers/documentUploadUtils';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  pendingFile,
  selectedDocument,
  uploadType,
  isUploading,
}) => {
  if (!pendingFile || !selectedDocument) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!isUploading) {
          onClose();
        }
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Confirmar subida</DialogTitle>
      <DialogContent>
        <Box sx={{ py: 1, display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            {uploadType === 'camera' ? (
              <CameraAltIcon sx={{ mr: 1, fontSize: 16, color: 'text.secondary' }} />
            ) : (
              <DescriptionIcon sx={{ mr: 1, fontSize: 16, color: 'text.secondary' }} />
            )}
            <Typography fontSize={14} style={{ fontWeight: 500, color: '#666' }}>
              {uploadType === 'camera' ? 'Foto:' : 'Archivo:'}
            </Typography>
          </Box>

          <Typography
            fontSize={14}
            style={{
              marginBottom: '8px',
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              hyphens: 'auto',
              maxWidth: '100%',
            }}
          >
            {pendingFile.name}
          </Typography>

          <Typography fontSize={14} style={{ marginBottom: '8px' }}>
            Tamaño: {DocumentUploadUtils.formatFileSize(pendingFile.size)}
          </Typography>

          <Typography fontSize={14} style={{ marginBottom: '16px' }}>
            Documento: {selectedDocument.displayName}
          </Typography>

          {uploadType === 'camera' && (
            <Box
              sx={{
                p: 1,
                backgroundColor: 'primary.50',
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'primary.200',
                mb: 2,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CameraAltIcon sx={{ mr: 1, fontSize: 16, color: 'primary.600' }} />
                <Typography fontSize={12} style={{ color: '#1976d2' }}>
                  Asegúrate de que la foto sea clara y legible
                </Typography>
              </Box>
            </Box>
          )}

          {selectedDocument.name?.includes('certificado') && (
            <Box
              sx={{
                p: 1,
                backgroundColor: 'primary.50',
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'primary.200',
                mb: 2,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <InfoIcon sx={{ mr: 1, fontSize: 16, color: 'primary.600' }} />
                <Typography fontSize={12} style={{ color: '#1976d2' }}>
                  Solo se permiten archivos PDF para certificados
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-end' }}>
        <MuiButton onClick={onClose} disabled={isUploading}>
          Cancelar
        </MuiButton>
        <MuiButton onClick={onConfirm} disabled={isUploading} variant="contained">
          {isUploading ? 'Subiendo...' : 'Subir'}
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  pendingFile: PropTypes.shape({
    name: PropTypes.string,
    size: PropTypes.number,
  }),
  selectedDocument: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
  }),
  uploadType: PropTypes.string,
  isUploading: PropTypes.bool.isRequired,
};

ConfirmationDialog.defaultProps = {
  pendingFile: null,
  selectedDocument: null,
  uploadType: null,
};

export default ConfirmationDialog;
